import api from '../api';
import { ContractPicklistItem, ContractPicklistKind } from '../../types/compliance';

// NOTE: axios baseURL already ends in `/api/v1`; paths here are relative.
// The Department and Category lists behind Compliance → Settings. Edits are
// for compliance managers; renames carry the contracts along, and a delete
// is refused while any contract uses the item.
const BASE: Record<ContractPicklistKind, string> = {
  departments: '/compliance/contract-departments',
  categories: '/compliance/contract-categories',
};

export const contractPicklistsService = {
  async list(kind: ContractPicklistKind): Promise<ContractPicklistItem[]> {
    const { data } = await api.get<ContractPicklistItem[]>(BASE[kind]);
    return data;
  },

  async create(kind: ContractPicklistKind, name: string): Promise<ContractPicklistItem> {
    const { data } = await api.post<ContractPicklistItem>(BASE[kind], { name });
    return data;
  },

  async rename(kind: ContractPicklistKind, id: number, name: string): Promise<ContractPicklistItem> {
    const { data } = await api.patch<ContractPicklistItem>(`${BASE[kind]}/${id}`, { name });
    return data;
  },

  /** `ids` is every item, in the new order. */
  async reorder(kind: ContractPicklistKind, ids: number[]): Promise<void> {
    await api.put(`${BASE[kind]}/order`, { ids });
  },

  async remove(kind: ContractPicklistKind, id: number): Promise<void> {
    await api.delete(`${BASE[kind]}/${id}`);
  },
};

export default contractPicklistsService;
